import {useIdleTimer} from 'react-idle-timer'
import {useCallback} from 'react'
import logout from '@/logout'

export default (timeout, url) => {
  const handleIdle = useCallback(() => {
    logout(window.location, url)
  }, [url])

  useIdleTimer({
    timeout,
    onIdle: handleIdle,
    debounce: 500,
  })
}



// WEBPACK FOOTER //
// ./src/idle-logout.js